import moment from "moment";
import React, { useState } from "react";
import { Media } from "reactstrap";
import { useHistory } from "react-router-dom";
import { ReactComponent as Eye } from "../../assets/img/EyeIcon.svg";
import { ReactComponent as Edit } from "../../assets/img/EditIcon.svg";
import { ReactComponent as Del } from "../../assets/img/delIcon.svg";
import { ReactComponent as Download } from "../../assets/img/downloadIcon.svg";
import { ReactComponent as Add } from "../../assets/img/addIcon.svg";
import { ReactComponent as Arrow } from "../../assets/img/Arrowdown.svg";
import CustomSelect from "components/Common/CustomDropdown";
import { mediaUrl } from "config";
import ConfirmationModal from "components/Common/ConfirmationModal";
import OrderSettings from "views/Orders/OrderSettings";
import BatchCard from "components/Orders/BatchCard";
import ShareBatchModal from "components/Orders/ShareBatchModal";

// Inline SVG gear icon for settings
const GearIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
);

// Inline SVG placeholder for missing product images
const placeholderImg = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='44' height='44' viewBox='0 0 44 44'%3E%3Crect width='44' height='44' rx='8' fill='%23F3F3F3'/%3E%3Cpath d='M16 28l4-5 3 3.5 4-5 5 6.5H12z' fill='%23C4C4C4'/%3E%3Ccircle cx='17' cy='17' r='3' fill='%23C4C4C4'/%3E%3C/svg%3E";

const DetailTable = ({
    arr,
    index,
    handleModal,
    handleEditOrder,
    handleEditBatchOrder,
    item,
    handleDelOrder,
    handleDelBatch,
    handleExportorderBatchcode,
    getOrders,
    onApproveStart,
    allOrders
}) => {
    // const isEnabled =
    //     item.batchIds.length === 0 || !item.batchIds.some(batch => batch.status === "pending");
    const history = useHistory();
    const pendingBatch = item?.batchIds?.find(batch => batch.status === "pending");

    const approvedBatch = item?.batchIds?.find(batch => batch.status === "approved" || batch.status === 'invalidated');
    const approvedBatchIds = (item?.batchIds || [])
        .filter(batch => batch.status === "approved") // Get all approved batches
        .map(batch => batch._id); // Extract only the batch IDs


    const [openDetail, setOpenDetail] = useState();
    const [confirmModal, setConfirmModal] = useState();
    const [confirmModalBatch, setConfirmModalBatch] = useState();
    const [selectedId, setSelectedId] = useState();
    const [orderSettingsModal, setOrderSettingsModal] = useState(false);
    const [shareOrderOpen, setShareOrderOpen] = useState(false);

    const handleConfirmModal = (id) => {
        setConfirmModal((prev) => !prev);
        setSelectedId(id)
    };
    const handleConfirmBatchModal = (id) => {
        setConfirmModalBatch((prev) => !prev);
        setSelectedId(id)
    };
    const handleOrderSettingsModal = () => {
        setOrderSettingsModal((prev) => !prev);
    };

    return (
        <>
            <tr
                style={{
                    fontFamily: "Outfit",
                    color: "#1C1C1C",
                }}
                className="bg-white"
            >
                <th
                    style={{
                        borderBottomLeftRadius:
                            arr[arr.length - 1] === index ? "10px" : "0px",
                        verticalAlign: "middle",
                    }}
                >
                    <div
                        style={{
                            cursor: "pointer",
                            transition: "0.3s",
                            rotate: openDetail ? "none" : "-90deg",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                        }}
                        onClick={() => {
                            setOpenDetail(!openDetail);
                        }}
                    >
                        <Arrow />
                    </div>
                </th>
                <td scope="row" style={{ padding: '12px 10px', fontSize: '13px', whiteSpace: 'nowrap' }}>
                    <span className="mb-0 text-sm" title={item?._id}>
                        {item?._id ? item._id.slice(-8).toUpperCase() : ''}
                    </span>
                </td>
                <td style={{ padding: '12px 10px', fontSize: '13px' }}>
                    {/* {item.email?.length > 30
                ? item.email?.substring(0, 30) + '...'
                : item.email} */}
                    {item?.brandId?.name}
                </td>
                <td style={{ padding: '12px 10px', fontSize: '13px', textAlign: 'center' }}>
                    {/* Batch count */}
                    {item.batchIds.length?.toLocaleString()}
                </td>
                <td style={{ padding: '12px 10px', fontSize: '13px', textAlign: 'center' }}>
                    {/* {item._id} */}
                    {Array.isArray(item.batchIds)
                        ? item.batchIds.reduce((sum, batch) => sum + (batch.number_of_codes || 0), 0).toLocaleString()
                        : 0}
                </td>

                <td style={{ padding: '12px 10px', fontSize: '13px', textAlign: 'center' }}>{item?.totalScansOfOrder?.toLocaleString()}</td>
                {/* <td>{item.invitationStatus.charAt(0).toUpperCase() + item.invitationStatus.slice(1)}</td> */}
                <td style={{ padding: '12px 10px' }}>
                    <div
                        className="rounded-pill d-flex justify-content-center align-items-center px-3 py-1"
                        style={{
                            backgroundColor: item.batchIds.length === 0 || pendingBatch ? "rgba(255, 0, 0, 0.1)" : "rgba(0, 178, 7, 0.1)",
                        }}
                    >
                        <span
                            style={{
                                color: item.batchIds.length === 0 || pendingBatch ? "red" : "#00B207",
                                fontSize: "12px",
                                fontWeight: 400,
                            }}
                        >
                            {item.batchIds.length === 0 || pendingBatch ? "Pending" : "Approved"}
                        </span>
                    </div>

                </td>

                <td style={{ padding: '12px 10px', fontSize: '13px', whiteSpace: 'nowrap' }}>{moment(item.createdAt).format("MMM DD, YYYY")}</td>
                <td style={{ padding: '12px 10px', fontSize: '13px' }}>
                    <div
                        style={{ gap: "6px" }}
                        className="d-flex justify-content-between align-items-center"
                    >
                        <span className="vs-action-icon" title="View on Activity Map" onClick={() => history.push(`/admin/map?orderId=${item._id}`)}>
                            <Eye />
                        </span>
                        <span className={`vs-action-icon ${approvedBatch ? 'disabled' : ''}`} title={!approvedBatch ? "Edit order" : "Cannot edit - has approved batches"}>
                            <Edit onClick={() => { if (!approvedBatch) handleEditOrder(item); }} />
                        </span>
                        <span className={`vs-action-icon destructive ${approvedBatch ? 'disabled' : ''}`} title={!approvedBatch ? "Delete order" : "Cannot delete - has approved batches"}>
                            <Del onClick={() => { if (!approvedBatch) handleConfirmModal(item._id); }} />
                        </span>
                        <span className={`vs-action-icon ${!approvedBatch ? 'disabled' : ''}`} title={approvedBatch ? "Share order via email" : "No approved batches to share"}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ cursor: approvedBatch ? "pointer" : "not-allowed" }}
                                onClick={() => { if (approvedBatch) setShareOrderOpen(true); }}
                            >
                                <circle cx="18" cy="5" r="3" />
                                <circle cx="6" cy="12" r="3" />
                                <circle cx="18" cy="19" r="3" />
                                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                            </svg>
                        </span>
                        <span className={`vs-action-icon ${!approvedBatch ? 'disabled' : ''}`} title={approvedBatch ? "Download codes CSV" : "No approved batches to download"}>
                            <Download onClick={() => { if (approvedBatch) handleExportorderBatchcode(approvedBatchIds, item.brandId?.name, "batch name", null); }} />
                        </span>
                        <span className="vs-action-icon" title="Order code settings" onClick={handleOrderSettingsModal}>
                            <GearIcon />
                        </span>
                        <span className="vs-action-icon" title="Add new batch">
                            <Add onClick={() => { handleModal(item); }} />
                        </span>
                    </div>
                </td>
                <td
                    style={{
                        borderBottomRightRadius:
                            arr[arr.length - 1] === index ? "10px" : "0px",
                    }}
                >
                    <CustomSelect
                        item={item}
                        options={[
                            {
                                label: "Pending",
                                value: "pending",
                            },

                            {
                                label: "Approved",
                                value: "approved",
                            },


                        ]}
                        status={item.batchIds.length === 0 ? "pending" : pendingBatch ? "pending" : "approved"}
                        getOrders={getOrders}
                        onApproveStart={onApproveStart}
                    />
                </td>
            </tr>

            {openDetail && item.batchIds.length > 0 && (
                <tr>
                    <td colSpan="10" style={{ padding: 0, border: 'none' }}>
                        {item.batchIds.map((batch) => (
                            <BatchCard
                                key={batch._id}
                                batch={batch}
                                order={item}
                                getOrders={getOrders}
                                onConfirmDelete={(batchId) => {
                                    handleConfirmBatchModal(batchId);
                                }}
                                handleExportorderBatchcode={handleExportorderBatchcode}
                                allOrders={allOrders}
                            />
                        ))}
                    </td>
                </tr>
            )}

            {confirmModal && <ConfirmationModal
                handleModal={handleConfirmModal}
                heading="Delete Order"
                message="Are you sure you want to delete this order?"
                handleConfirm={() => {
                    handleDelOrder(selectedId)
                    setConfirmModal((prev) => !prev);
                }}
            />}
            {confirmModalBatch && <ConfirmationModal
                handleModal={handleConfirmBatchModal}
                heading="Delete Batch"
                message="Are you sure you want to delete this batch?"
                handleConfirm={() => {
                    handleDelBatch(selectedId)
                    setConfirmModalBatch((prev) => !prev);
                }}
            />}
            <ShareBatchModal
                isOpen={shareOrderOpen}
                toggle={() => setShareOrderOpen(false)}
                batchIds={approvedBatchIds}
                brandName={item?.brandId?.name}
                orderName={item?.description || `Order ${String(item?._id || '').slice(-6)}`}
            />
            {orderSettingsModal && <OrderSettings
                handleModal={handleOrderSettingsModal}
                selectedOrder={item}
                getOrders={getOrders}
            />}
        </>
    );
};

export default DetailTable;
